module.exports = __webpack_public_path__ + "static/media/salesforce-integration.df4922b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salesforce-integration.png
// module id = 1311
// module chunks = 1